import React, { memo } from "react";
import { DLS_TEXT_VARIANTS } from "../../constants/dls";
import { Images } from "../../constants/images";
import { ErrorContainer, WarningImage, ErrorMessage, StyledRetryButton } from "../../styles/errorComponent";

interface ErrorComponentProps {
    onRetry: () => void;
}

const ErrorComponent = ({ onRetry }: ErrorComponentProps) => {
    return (
        <ErrorContainer>
            <WarningImage src={Images.warning} />
            <ErrorMessage variant={DLS_TEXT_VARIANTS.BODY_B1_REG}>Something went wrong</ErrorMessage>
            <StyledRetryButton variant="primary" onClick={onRetry}>
                Try Again
            </StyledRetryButton>
        </ErrorContainer>
    );
};

export default memo(ErrorComponent);
